import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { UserCampaingsTable } from "../../../UI/Users/UserCampaign/UserCampaingsTable";

const UserCampaignsPanel = () => {
  return (
    <div>
      <PanelHead title="User Email Campaign" />
      <PanelBody content={<UserCampaingsTable />} />
    </div>
  );
};

export default React.memo(UserCampaignsPanel);
